import { ApplicationStatusName } from 'enums/ApplicationStatusName';

export const isConfirmedLoanOffer = (status?: ApplicationStatusName): boolean =>
  status === ApplicationStatusName.OfferAvailable;

export const isProbableLoanOffer = (status?: ApplicationStatusName): boolean =>
  status === ApplicationStatusName.OfferPresented;

export const hasLoanOfferToShow = (status?: ApplicationStatusName): boolean =>
  isConfirmedLoanOffer(status) || isProbableLoanOffer(status);
